import { useAppScopeStore } from '@frontend/scope';
import { useSelectedLocationContext } from '../../providers';

/**
 * This hook returns the first selected location from the global filter or the SelectedLocationProvider context.
 *
 * @returns {object} An object containing the selected location and locationId.
 */
export const useFirstSelectedLocation = () => {
  const selectedLocation = useSelectedLocationContext();
  const { selectedLocationIds } = useAppScopeStore();

  // locationId is the first location id in the selectedLocationIds array or in the selectedLocationContext
  const locationId = selectedLocation?.[0] ?? selectedLocationIds[0];

  return { locationId, locationIds: selectedLocation ?? selectedLocationIds };
};
